/*------------------------------------*\
    FORM REVIEW
\*------------------------------------*/
class FormReview {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.populateTable();
        self.populateHiddenFields();
        self.submit();
    }

    populateTable() {
        let self = this;
        let table = self.elem.querySelector('[data-fields]');

        // Get all item from local storage
        let fields = self.getLocalStorage();

        fields.sort(function(a, b){
            if(a.name < b.name) {
                return -1;
            }

            if(a.name > b.name) {
                return 1;
            }

            return 0;
        });

        // Loop through the items
        fields.forEach(field => {
            // Create the markup for a table row
            let markup = `
                <tr>
                    <th scope="row">${field.label}</th>
                    <td>${self.nl2br(field.value)}</td>
                </tr>
            `;

            // Insert the table row inside the table body
            table.insertAdjacentHTML('beforeend', markup);
        });
    }

    populateHiddenFields() {
        let self = this;

        // Get all item from local storage
        let fields = self.getLocalStorage();

        fields.sort(function(a, b){
            if(a.name < b.name) {
                return -1;
            }

            if(a.name > b.name) {
                return 1;
            }

            return 0;
        });

        // Loop through the items
        fields.forEach(field => {
            // Create the markup for a hidden input
            let markup = `
                <input type="hidden" name="${field.name}" value="${field.value}">
            `;

            // Insert the hidden input inside the form element
            self.elem.insertAdjacentHTML('beforeend', markup);
        });
    }

    // Get all items from local storage and convert to array
    // containing an object for each item
    getLocalStorage() {
        let self = this;

        let archive = [],
            keys = Object.keys(localStorage),
            i = 0, key;

        for (; key = keys[i]; i++) {
            let data = JSON.parse(localStorage.getItem(key));

            archive.push({
                'name': key,
                'label': data.label,
                'value': data.value
            });
        }

        return archive;
    }

    submit() {
        let self = this;

        // When the form submit button is clicked...
        self.elem.addEventListener('submit', evt => {
            // Prevent the form from submitting
            evt.preventDefault();

            // Clear local storage
            localStorage.clear();

            // Submit the form
            self.elem.submit();
        });
    }

    // Convert carriage returns to line breaks for displaying textarea
    // content in the table
    nl2br(str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
}

export default FormReview;
